import { render } from "./MediaIconEditor.vue?vue&type=template&id=7baa1f4d&scoped=true"
import script from "./MediaIconEditor.vue?vue&type=script&lang=js"
export * from "./MediaIconEditor.vue?vue&type=script&lang=js"

import "./MediaIconEditor.vue?vue&type=style&index=0&id=7baa1f4d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baa1f4d"]])

export default __exports__